import * as React from "react"
import { useEffect } from "react"
import { Box } from "@mui/material"

import { CommonFiltersMarketplaces } from "@components"
import {COMMON_FILTER_KEYS, MARKETPLACES_ROUTES} from "@constants"
import { useAppDefaultFilters } from "@hooks"
import { useMarketplacesSearch } from "./@hooks"


export default function MarketplacesGeneralFilters() {
	const { handleSubmit } = useMarketplacesSearch()
	const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(MARKETPLACES_ROUTES.OVERVIEW_ID, MARKETPLACES_ROUTES.ACCESS_KEY)

	useEffect(() => {
		callUserDefaultFilters()
	}, [])

    return <Box data-tour="mp-general-filters">
	<CommonFiltersMarketplaces
		components={{ productsInStock: true }}
		compProps={{
			productsInStock : { grid: { md: 2 } },
			withShippingPrice: { grid: { md: 3 } },
			favFilters: {
				allowedFilters: [
					COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
					COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU, COMMON_FILTER_KEYS.SPLIT_KPI, COMMON_FILTER_KEYS.BUY_BOX,
					COMMON_FILTER_KEYS.AUTHORIZED_SELLER, COMMON_FILTER_KEYS.INCLUDE_SHIPPING_PRICE
				],
				dashboardKey: MARKETPLACES_ROUTES.OVERVIEW_ID
			}
		}}
		onSubmit={handleSubmit}
		userFilters={userFilters}
		isLoadingDefaultFilters={isLoadingDefaultFilters}
	/>
	</Box>
}